module.exports = __webpack_public_path__ + "media/assets/login/icon-baby-5485b90dd645dff2fa623e24158eaab5.svg";